import { createFileRoute, Navigate } from '@tanstack/react-router';
import { pageTitle, usePageTitle } from '@/utils/pageTitle';
import { ArticleTable } from '@/components/Pages/Articles/ArticleTable';
import { CreateEditArticleModal } from '@/components/Pages/Articles/CreateEditArticleModal';
import { Box } from '@mui/joy';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/articles/')({
  component: ArticlesPage,
  head: () => pageTitle('Artículos'),
});

function ArticlesPage() {
  usePageTitle('Artículos');
  const { hasClaim, isLoading } = useAuth();
  const canRead = hasClaim('ARTICLES_READ');
  const canWrite = hasClaim('ARTICLES_WRITE');

  if (!isLoading && !canRead) {
    return <Navigate to='/' />;
  }

  return (
    <Box>
      {canWrite && (
        <Box
          sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3, gap: 2 }}
        >
          <CreateEditArticleModal isService={false} />
          <CreateEditArticleModal isService={true} />
        </Box>
      )}
      <ArticleTable />
    </Box>
  );
}
